var exports = {
  "Qs": "AccountDeleteModal.module__content___bjVESn",
  "iY": "AccountDeleteModal.module__infoSection___bjVESn",
  "rf": "AccountDeleteModal.module__infoHeading___bjVESn",
};

module.exports = exports;
